import { render } from "./CreditNoteAdditionalForm.vue?vue&type=template&id=08f4f218"
import script from "./CreditNoteAdditionalForm.vue?vue&type=script&lang=js"
export * from "./CreditNoteAdditionalForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__